import { documentUrl as docFileHref } from "@/lib/images";
// Sipariş/Transfer çalışma alanı — paylaşılan sabitler ve sunum bileşenleri (monolit OrdersWorkspace bölme).
import { FileText } from "lucide-react";

export const TYPE_FILTERS = [
  { v: "", l: "Tümü" },
  { v: "internal_order", l: "İç İkmal" },
  { v: "purchase_order", l: "Satın Alma" },
  { v: "transfer", l: "Manuel Transfer" },
];

// S1 — Sevkiyat şekli
export const SHIPMENT_METHODS = [
  { v: "nakliye", l: "Nakliye / Kargo" },
  { v: "getiren_kendisi", l: "Getiren Kendisi" },
  { v: "bizim_aracimiz", l: "Bizim Aracımız (kayıtlı)" },
  { v: "diger", l: "Diğer" },
];
export const SHIP_LABEL = Object.fromEntries(SHIPMENT_METHODS.map((s) => [s.v, s.l]));

// S3 — sevk/mal kabul belge türleri
export const DOC_TYPES = [
  { v: "irsaliye", l: "İrsaliye" },
  { v: "fatura", l: "Fatura" },
  { v: "makbuz", l: "Makbuz" },
  { v: "diger", l: "Diğer" },
];

export { docFileHref };

export const DocSummary = ({ doc, label }) => {
  if (!doc) return null;
  return (
    <div data-testid={`detail-doc-${label}`} className="rounded-md border border-slate-200 bg-white p-2 text-[12px] text-slate-600">
      <p className="mb-1 flex flex-wrap items-center gap-x-3 gap-y-0.5">
        <span className="inline-flex items-center gap-1 font-semibold text-slate-700"><FileText className="h-3.5 w-3.5 text-brand-green" /> {label}: {doc.doc_type_label}{doc.doc_no ? ` — ${doc.doc_no}` : ""}{doc.doc_detail ? ` — ${doc.doc_detail}` : ""}</span>
        {doc.delivered_by && <span>Getiren: <b>{doc.delivered_by}</b>{doc.delivered_by_phone ? ` · ${doc.delivered_by_phone}` : ""}</span>}
      </p>
      {(doc.doc_urls || []).length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {doc.doc_urls.map((u, i) => (
            <a key={i} href={docFileHref(u)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-emerald-700 ring-1 ring-inset ring-emerald-200 hover:bg-emerald-100">
              <FileText className="h-3 w-3" /> Belge {i + 1}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export const StatCard = ({ label, value, icon: Icon, cls }) => (
  <div className="rounded-lg bg-white p-3 ring-1 ring-inset ring-slate-200">
    <div className="flex items-center gap-1.5 text-[11px] font-medium text-slate-500"><Icon className={`h-3.5 w-3.5 ${cls || "text-slate-400"}`} /> {label}</div>
    <p className="mt-1 text-lg font-bold text-slate-800 tabular">{value}</p>
  </div>
);
